var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0033 2.75C8.58654 2.74769 5.24468 4.73032 4.35146 8.65591C3.2944 13.3261 6.18812 17.3762 8.91023 19.9997C10.6407 21.661 13.3607 21.659 15.0792 20.0004L15.0806 19.999C17.8125 17.3756 20.7057 13.3354 19.6485 8.6656C18.76 4.73974 15.4202 2.75231 12.0033 2.75ZM21.1115 8.33441C20.04 3.60029 15.9848 1.25269 12.0043 1.25C8.02366 1.24731 3.96565 3.58953 2.88872 8.32364C1.64602 13.8131 5.07183 18.3836 7.86958 21.08L7.87053 21.0809C10.1799 23.2989 13.8192 23.3008 16.1205 21.08C18.9284 18.3834 22.3542 13.8239 21.1115 8.33441ZM12 7.94C10.6911 7.94 9.63003 9.00109 9.63003 10.31C9.63003 11.6189 10.6911 12.68 12 12.68C13.3089 12.68 14.37 11.6189 14.37 10.31C14.37 9.00109 13.3089 7.94 12 7.94ZM8.13003 10.31C8.13003 8.17266 9.86269 6.44 12 6.44C14.1374 6.44 15.87 8.17266 15.87 10.31C15.87 12.4473 14.1374 14.18 12 14.18C9.86269 14.18 8.13003 12.4473 8.13003 10.31Z",
    fill: "#515E5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.0780c607d824a644217be752c7b03c47.svg";
export { ForwardRef as ReactComponent };